import React from "react";
import { VariantBase } from "scmp-sdk/components/newsletter/newsletter-widget/variants/component";

import { Container, theme } from "./styles";

export { ArticleThemeSignUpButtonDisplay } from "./article-theme-sign-up-button-display";
export { ArticleThemeTitle } from "./article-theme-title";
export * from "./hooks";

export const ArticleTheme: React.FunctionComponent<{ children?: React.ReactNode }> = ({
  children,
  ...props
}) => (
  <VariantBase theme={theme}>
    <Container {...props}>{children}</Container>
  </VariantBase>
);

ArticleTheme.displayName = "ArticleTheme";
